// extracted by mini-css-extract-plugin
module.exports = {"probation_salary_rate":"ProbationSetting__probation_salary_rate--5W4-K"};